// extracted by mini-css-extract-plugin
export default {"noti-card":"NotiCard_noti-card__WSr4+","active":"NotiCard_active__YDfGc"};